import axios from 'axios';
import { tokenStorage } from '@/infrastructure/storage/tokenStorage';

interface ApiEnvelope<T> {
  success: boolean;
  message: string;
  data: T;
}

export const httpClient = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

httpClient.interceptors.request.use((config) => {
  const token = tokenStorage.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => {
    const body = response.data as ApiEnvelope<unknown>;
    if (body && typeof body === 'object' && 'success' in body && 'data' in body) {
      response.data = body.data;
    }
    return response;
  },
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      tokenStorage.removeToken();
    }
    return Promise.reject(error);
  },
);
